import { Controller } from '@hotwired/stimulus';

export class DisplayController extends Controller {
  static classes = ['hidden'];
  static targets = ['item'];

  connect() {
    this.class = this.hasHiddenClass ? this.hiddenClass : 'hidden';
  }

  hide(event) {
    const value = event.params?.value;

    this.itemTargets.forEach(item => {
      if (!value || item.dataset.displayValue === value) {
        item.classList.add(this.class);
      }
    });

    if (event.params?.hideTarget) event.target.classList.add('hidden');
  }

  show(event) {
    const value = event.params?.value;

    this.itemTargets.forEach(item => {
      if (!value || item.dataset.displayValue === value) {
        item.classList.remove(this.class);
      }
    });

    if (event.params?.hideTarget) event.target.classList.add('hidden');
  }

  toggle(event) {
    const value = event?.params?.value;

    this.itemTargets.forEach(item => {
      if (!value || item.dataset.displayValue === value) {
        item.classList.toggle(this.class);
      }
    });
  }
}
